export default "__VITE_ASSET__C$vwCOxd__"